
export const usePresentationArea = () => {
  const breakIconText = () => {
    const elements = document.querySelectorAll('.icon-block__text');
    elements.forEach((element) => {
        let text = element.textContent.split(/([A-Za-z]+)(.*)/, 2);
        let last = text.pop();
        element.innerHTML = text.join() + (text.length > 0 ? ' <span class="icon-block__text-metric-unit">' + last + '</span>' : last);
    });
}

    breakIconText();
}

document.addEventListener('DOMContentLoaded', () => {
  usePresentationArea();
});